/**
 * Repeated URL query-param helpers shared by the search, item-list and gallery
 * filter state (tickets 09/10). Empty values are meaningful here: `owner=`
 * selects the "Unassigned" owner, so unlike a generic truthy filter these
 * helpers preserve `""`.
 */

/** Every value for a repeated parameter, including empty values. */
export function readValues(params: URLSearchParams, key: string): string[] {
  return params.getAll(key);
}

/** Replace every value for a parameter; empty strings become `key=`. */
export function writeValues(
  params: URLSearchParams,
  key: string,
  values: readonly string[],
): void {
  params.delete(key);
  for (const value of values) {
    params.append(key, value);
  }
}
